export const ROWS_PER_PAGE_OPTIONS = [5, 10, 25, { label: 'Tout', value: -1 }]

export const TABLE_CONTACT_COLUMNS = ['nom', 'prenom', 'email', 'telephone', 'typeContact', 'origine']

export const FILTRE_TEXTE = 'filtre_texte'